"use client";

// src/base/tab-item-base.ts
import { BaseItem } from "@heroui/aria-utils";
var TabItemBase = BaseItem;
var tab_item_base_default = TabItemBase;

export {
  tab_item_base_default
};
